import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    headerRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 20,
    },
    microLabel: {
        textTransform: 'uppercase',
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: '0.08em',
        color: '#6b7280',
        marginBottom: 4,
    },
    planNameRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '8px',
    },
    planName: {
        fontSize: 24,
        fontWeight: 700,
        color: theme.palette.primary.main,
        marginRight: 12,
    },
    priceBox: {
        textAlign: 'right',
        whiteSpace: 'nowrap',
    },
    price: {
        fontSize: 24,
        fontWeight: 700,
        color: theme.palette.primary.main,
    },
    priceUnit: {
        fontSize: 14,
        fontWeight: 400,
        color: theme.palette.primary.main,
    },
}));
